var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        name: "modal-request-custom-design",
        pivotY: 0.2,
        width: 1200,
        height: "auto"
      }
    },
    [
      _c("div", { staticClass: "modal-close-btn-point" }, [
        _c(
          "div",
          {
            staticClass: "modal-close-btn-container",
            on: {
              click: function($event) {
                return _vm.hideModal("modal-request-custom-design")
              }
            }
          },
          [_c("SVGModalClose")],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-title-big" }, [
        _vm._v("\n            Применить выбранный дизайн на свой дом\n        ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-text" }, [
        _vm._v(
          "\n            Отправьте фотографии Вашего проекта и оставьте свои контактные данные. Наши менеджеры вскоре свяжутся с Вами!\n        "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cd-modal-outer-grid" }, [
        _c("div", [
          _c("div", [
            _c("div", { staticClass: "cd-modal-grid-element" }, [
              _c(
                "div",
                {
                  staticClass: "dnd-container",
                  on: {
                    drop: function($event) {
                      $event.preventDefault()
                      return _vm.receiveFiles($event)
                    },
                    dragover: function($event) {
                      $event.preventDefault()
                      _vm.dragover = true
                    },
                    dragleave: function($event) {
                      $event.preventDefault()
                      _vm.dragover = false
                    },
                    click: function($event) {
                      return _vm.$refs.file.click()
                    }
                  }
                },
                [
                  _c("SVGPhotoDnDLoad", {
                    staticClass: "cd-dnd-svg",
                    attrs: { dragover: _vm.dragover }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("input", {
                ref: "file",
                attrs: {
                  type: "file",
                  id: "fileInputModal",
                  accept: ".jpg,.png",
                  multiple: "",
                  hidden: ""
                },
                on: {
                  change: function($event) {
                    return _vm.handleFileUpload($event)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              Object.keys(_vm.uploadedPhotos).length === 0
                ? _c(
                    "div",
                    { staticClass: "cd-modal-grid-element cd-photo-tips" },
                    [
                      _c("ul", [
                        _c("li", { staticClass: "cd-modal-list" }, [
                          _vm._v(
                            "\n                                Размер файла не более 15 МБ\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "cd-modal-list" }, [
                          _vm._v(
                            "\n                                Форматы: JPG, JPEG, PNG\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "cd-modal-list" }, [
                          _vm._v(
                            "\n                                Изображение объекта в фокусе\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "cd-modal-list" }, [
                          _vm._v(
                            "\n                                Ракурс без заваленных вертикальных линий\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "cd-modal-list" }, [
                          _vm._v(
                            "\n                                Здание полностью помещается в кадр\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "cd-modal-list" }, [
                          _vm._v(
                            "\n                                Фото сделано при достаточном освещении\n                            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "cd-modal-list" }, [
                          _vm._v(
                            "\n                                На фото отсутствуют посторонние объекты, мешающие обзору\n                            "
                          )
                        ])
                      ])
                    ]
                  )
                : _c(
                    "vue-custom-scrollbar",
                    { staticClass: "margin-10-20 cd-modal-img-blocks" },
                    _vm._l(_vm.uploadedPhotos, function(img) {
                      return _c("div", { staticClass: "modal-img-block" }, [
                        _c("img", {
                          staticClass: "modal-img-block-image",
                          attrs: { src: _vm.urlForPhoto(img.src) }
                        })
                      ])
                    }),
                    0
                  )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "cd-modal-grid no-mt" }, [
            _c("div", [
              _c("div", { staticClass: "cd-modal-grid-element margin-10-20" }, [
                _vm._v("\n                            ФИО (Полностью) "),
                _c("span", { staticClass: "red-text" }, [_vm._v("*")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cd-modal-grid-element" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.name,
                      expression: "name"
                    }
                  ],
                  staticClass: "cd-modal-text-input",
                  attrs: { type: "text", placeholder: "Ваше полное имя *" },
                  domProps: { value: _vm.name },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.name = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showAlert === "name",
                        expression: "showAlert === 'name'"
                      }
                    ],
                    staticClass: "form-alert-danger"
                  },
                  [
                    _vm._v(
                      "\n                                Обязательное поле!\n                            "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cd-modal-grid-element margin-10-20" }, [
                _vm._v(
                  "\n                            Адрес электронной почты "
                ),
                _c("span", { staticClass: "red-text" }, [_vm._v("*")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cd-modal-grid-element" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.email,
                      expression: "email"
                    }
                  ],
                  staticClass: "cd-modal-text-input",
                  attrs: {
                    type: "text",
                    placeholder: "Ваша электронная почта *"
                  },
                  domProps: { value: _vm.email },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.email = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showAlert === "email",
                        expression: "showAlert === 'email'"
                      }
                    ],
                    staticClass: "form-alert-danger"
                  },
                  [
                    _vm._v(
                      "\n                                Обязательное поле!\n                            "
                    )
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", [
              _c("div", { staticClass: "cd-modal-grid-element margin-10-20" }, [
                _vm._v("\n                            Город "),
                _c("span", { staticClass: "red-text" }, [_vm._v("*")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "cd-modal-grid-element" },
                [
                  _c("SelectRegionCity", {
                    staticStyle: { height: "38px" },
                    attrs: { hideRegions: true, hideFieldLabels: true },
                    on: { citySelectedName: _vm.citySelectedName }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showAlert === "city",
                          expression: "showAlert === 'city'"
                        }
                      ],
                      staticClass: "form-alert-danger"
                    },
                    [
                      _vm._v(
                        "\n                                Обязательное поле!\n                            "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "cd-modal-grid-element margin-10-20" }, [
                _vm._v("\n                            Контактный телефон "),
                _c("span", { staticClass: "red-text" }, [_vm._v("*")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cd-modal-grid-element" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.phone,
                      expression: "phone"
                    },
                    {
                      name: "mask",
                      rawName: "v-mask",
                      value: "+# (###) ### ## ##",
                      expression: "'+# (###) ### ## ##'"
                    }
                  ],
                  staticClass: "cd-modal-text-input",
                  attrs: {
                    type: "text",
                    placeholder: "Ваш контактный телефон *"
                  },
                  domProps: { value: _vm.phone },
                  on: {
                    focus: _vm.addCountryCode,
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.phone = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showAlert === "phone",
                        expression: "showAlert === 'phone'"
                      }
                    ],
                    staticClass: "form-alert-danger"
                  },
                  [
                    _vm._v(
                      "\n                                Обязательное поле!\n                            "
                    )
                  ]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cd-modal-grid-element margin-10-30" }, [
            _c("div", { staticClass: "margin-10-0" }, [
              _vm._v(
                "\n                        Ваши комментарии:\n                    "
              )
            ]),
            _vm._v(" "),
            _c("div", [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.comment,
                    expression: "comment"
                  }
                ],
                staticClass: "cd-modal-text-input modal-textarea",
                attrs: { placeholder: "Дополнительная информация к заявке *" },
                domProps: { value: _vm.comment },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.comment = $event.target.value
                  }
                }
              })
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "button-alert-grid margin-30" }, [
        _c(
          "div",
          {
            staticClass: "gl-square-btn btn-grey",
            on: { click: _vm.submitSendRequest }
          },
          [_vm._v("\n                Отправить заявку\n            ")]
        ),
        _vm._v(" "),
        _c("div")
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }